module.exports = __webpack_public_path__ + "static/media/band-aid.d0ab86ce.svg";